import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MangaApiService from '../../services/MangaApiService';
import { getMangaErrorMessage, unwrapList } from '../manga/mangaStudioUtils';
import { MangaReviewCard } from '../manga/MangaReviews';

const PAGE_SIZE = 20;

/** Newest manga reviews across all titles. Reviews are published at once, so moderation means removing bad ones. */
const MangaReviewModeration = () => {
    const [reviews, setReviews] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [notice, setNotice] = useState(null);

    const load = useCallback(async (nextPage) => {
        setLoading(true);
        setError(null);
        try {
            const response = await MangaApiService.getRecentMangaReviews({ page: nextPage, size: PAGE_SIZE });
            const items = unwrapList(response);
            setReviews((previous) => (nextPage === 0 ? items : [...previous, ...items]));
            setHasMore(response?.last === false);
            setPage(nextPage);
        } catch (err) {
            setError(getMangaErrorMessage(err, 'Не удалось загрузить отзывы.'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load(0);
    }, [load]);

    const handleDelete = async (review) => {
        if (!window.confirm(`Удалить отзыв ${review.nick || 'пользователя'} на «${review.mangaTitle || 'тайтл'}»?`)) {
            return;
        }
        try {
            await MangaApiService.deleteMangaReview(review.id);
            setReviews((previous) => previous.filter((item) => item.id !== review.id));
            setNotice('Отзыв удалён, оценка тайтла пересчитана.');
        } catch (err) {
            setError(getMangaErrorMessage(err, 'Не удалось удалить отзыв.'));
        }
    };

    return (
        <div className="admin-page">
            <div className="anime-list manga-review-moderation-panel">
                <h2>Отзывы на мангу</h2>
                <p className="manga-help">
                    Отзывы публикуются сразу. Здесь самые новые: удаляйте оскорбления, спам и спойлеры.
                </p>
                {notice ? <div className="manga-inline-note">{notice}</div> : null}
                {error ? <div className="manga-inline-warning">{error}</div> : null}
                {reviews.length === 0 && !loading && !error ? <div className="manga-empty">Новых отзывов нет.</div> : null}
                <div className="reviews">
                    {reviews.map((review) => (
                        <div key={review.id}>
                            {review.mangaSlug ? (
                                <Link className="manga-team-link" to={`/manga/${review.mangaSlug}`}>
                                    {review.mangaTitle || 'Тайтл'}
                                </Link>
                            ) : null}
                            <MangaReviewCard review={review} canDelete onDelete={handleDelete} />
                        </div>
                    ))}
                </div>
                {hasMore ? (
                    <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" disabled={loading} onClick={() => load(page + 1)}>
                        {loading ? 'Загружаем...' : 'Показать ещё'}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default MangaReviewModeration;
